module.exports = __webpack_public_path__ + "static/img/4_5_1.60ebfd7d.jpg";